import { IconType } from "@jsq/ds/icons";
import { RefreshStatus } from "./types";

export type MenuAction = {
  label: string;
  onSelect: () => void;
  iconType?: IconType;
};

export const MENU_ACTION_KEYS = {
  RESEND_REFRESH_REQUEST: "Resend refresh request",
  CANCEL_REFRESH_REQUEST: "Cancel refresh request",
  VIEW_CASE: "View case",
  SEND_REFRESH_REQUEST: "Send refresh request",
  CREATE_CASE: "Create new case",
} as const;

export const MENU_OPTIONS_BY_STATUS: Record<string, Omit<MenuAction, "onSelect">[]> = {
  [RefreshStatus.RequestSent]: [
    {
      label: MENU_ACTION_KEYS.RESEND_REFRESH_REQUEST,
    },
    {
      label: MENU_ACTION_KEYS.CANCEL_REFRESH_REQUEST,
    },
    {
      label: MENU_ACTION_KEYS.VIEW_CASE,
      iconType: "external-link",
    },
  ],
  [RefreshStatus.RequestSentOverdue]: [
    {
      label: MENU_ACTION_KEYS.RESEND_REFRESH_REQUEST,
    },
    {
      label: MENU_ACTION_KEYS.CANCEL_REFRESH_REQUEST,
    },
    {
      label: MENU_ACTION_KEYS.VIEW_CASE,
      iconType: "external-link",
    },
  ],
  [RefreshStatus.Closed]: [
    {
      label: MENU_ACTION_KEYS.VIEW_CASE,
      iconType: "external-link",
    },
  ],
  [RefreshStatus.UpcomingRefresh]: [
    {
      label: MENU_ACTION_KEYS.SEND_REFRESH_REQUEST,
    },
    {
      label: MENU_ACTION_KEYS.CREATE_CASE,
    },
  ],
  [RefreshStatus.RefreshRequired]: [
    {
      label: MENU_ACTION_KEYS.SEND_REFRESH_REQUEST,
    },
    {
      label: MENU_ACTION_KEYS.CREATE_CASE,
    },
  ],
};
